export const FETCH_DATASETS = 'app@fetchDatasets';
export const FETCH_PAGINATED_DATASET = 'app@fetchPaginatedDataset';
export const FETCH_GRID_DATASET = 'app@fetchGridDataset';
export const SET_DATASET = '@setDataset';
export const SET_PAGINATED_DATASET = '@setPaginatedDataset';
export const SET_DATASET_LOADING = '@setDatasetLoading';
